// extracted by mini-css-extract-plugin
export var layout = "styles-module--layout--91d88";
export var left = "styles-module--left--755bd";
export var reverse = "styles-module--reverse--caf23";
export var right = "styles-module--right--d789e";